import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CardIcon from 'components/Card/CardIcon';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { wsFindBy, wsRemove } from 'services/WService';
import { WithApp } from 'contexts/appContext';
import { Add, Clear, RecentActors } from '@material-ui/icons';
import { Toasty, useToasty } from 'hooks/Toasty';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
});

export default WithApp(function BusinessPartner({
  cardType,
  permissions,
  entity = 'base/business-partner',
}) {
  const classes = useStyles();
  const isCustomer = cardType === 'C' ? true : false;
  const [processing, setProcessing] = useState(false);
  const [notify, showNotify] = useToasty();
  const [dataLoading, setDataLoading] = useState(false);

  const columns = [
    { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
    { Header: 'Nombre de cliente', accessor: 'business_name' },
    { Header: 'Zona', accessor: 'zone', width: 120 },
    { Header: 'Vendedor', accessor: 'SlpName', width: 250 },
    { Header: 'RUC/DNI', accessor: 'document_number', width: 130 },
    { Header: 'Fecha/Hora de creación', accessor: 'created_at', width: 200 },
    { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
  ];

  const [bPartners, setBPartners] = useState([]);

  const [valueSearch, setValueSearch] = useState({});

  async function getBPartners(search) {
    for (var clave in search) {
      if (search[clave] == null || search[clave] === '') {
        delete search[clave]; //eliminamos solo las claves vacias
      }
    }
    setDataLoading(true);
    let response = await wsFindBy(entity, { ...search, CardType: cardType });
    setDataLoading(false);
    if (response.success) {
      setBPartners(response.data);
    }
  }

  async function removeIncompleteBp(bPartner) {
    if (!window.confirm('Esta seguro de eliminar el registro?')) {
      return;
    }
    setProcessing(true);
    let res = await wsRemove('base/business-partner/incomplete', bPartner.id);
    setProcessing(false);
    if (res.success) {
      showNotify(res.message);
      setBPartners((bPartners) => {
        let newBPartners = [...bPartners];
        let index = newBPartners.findIndex((item) => item.id === bPartner.id);
        newBPartners.splice(index, 1);
        return newBPartners;
      });
    } else {
      showNotify(res.message, 'error');
    }
  }

  useEffect(() => {
    getBPartners(valueSearch);
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={permissions.store}
              component={
                <CardIcon color="primary">
                  <RecentActors style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <Link to={`${0}?type=${cardType}`}>
                <CardIcon pointer="true" color="success">
                  <Add style={{ color: 'white' }} />
                </CardIcon>
              </Link>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de clientes por aprobar {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName={'clientes-incompletos'}
              formatDate="DD-MM-YYYY HH:mm"
              defaultWidth={1000}
              columns={columns}
              data={bPartners.map((bPartner, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={permissions.show}>
                        <Button justIcon round simple size="sm" disabled={processing}>
                          <Link to={`${bPartner.id}`}>
                            <VisibilityIcon />
                          </Link>
                        </Button>
                        <Button
                          justIcon
                          round
                          simple
                          size="sm"
                          color="danger"
                          onClick={() => removeIncompleteBp(bPartner)}
                          disabled={processing}
                        >
                          <Clear />
                        </Button>
                      </AllowedGuard>
                    </div>
                  ),
                  business_name: bPartner.business_name,
                  document_number: bPartner.document_number,
                  zone: bPartner.base_zone_description || 'No disponible',
                  SlpName: bPartner.SlpName,
                  created_at: bPartner.created_at,
                  state:
                    bPartner.completed === 'N'
                      ? 'Incompleto'
                      : bPartner.frozenFor === 'N'
                      ? 'Activo'
                      : 'Inactivo',
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
        
      </GridItem>
    </GridContainer>
  );
});
